import React, {useEffect, useState} from "react";
import "./ManagementCurrentCard.scss";
import "./Customer.scss";
import { Spin } from 'antd';

import {useHistory} from "react-router-dom";
import Rodal from "rodal";
import {ManagementDriverCard} from "../ManagementDriverCard/ManagementDriverCard";
import {
    cancelSend_api,
    courierManagerCouriers,
    courierManagerOrderDetail,
    sendToMiare_api
} from "../SendManagementService";
import Expand from "react-expand-animated";
import moment from "moment-jalaali";
import {convertStatusCode} from "../../../Services";
import {courierOrderUpdate_api as ite} from "../../Peyk/PeykService";
import toaster from "toasted-notes";

function Error(props) {

    return(
        <div className="error_message-container">
            <span className="text-message">{props.message}</span>
        </div>
    )
}

function ManagementCurrentCard({it}) {

    const history = useHistory()
    const [showModal,set_showModal] = useState(false)
    const [showDetailModal,set_showDetailModal] = useState(false)
    const [drivers,set_drivers] = useState([])
    const [listDriverLadda,set_listDriverLadda] = useState(false)
    const [detailLadda,set_detailLadda] = useState(false)


    const [detail,set_detail] = useState([])
    const [driver,set_driver] = useState(null)
    const [attribExpand ,set_attribExpand] = useState(false);
    const [item ,set_item] = useState(false);


    useEffect(()=>{
        // it["delivery_type"] = "merchant";


        set_item(it)
        if(it.courier){
            set_driver(it.courier)
        }
    },[])

    const convertStack = (stack) =>{
        switch (stack) {
            case 'accepted':
                return "قبول"
                break;
            case 'noAccepted':
                return "ادامه"
                break;
        }
    }


    const statusDetail = async (id) =>{
        try{
            const response = await courierManagerOrderDetail(id);
            set_item({...item,status:response.data.status})
        }catch (e) {
            set_detailLadda(false)
        }
    }


    const showDetail = async (id) =>{
        set_detailLadda(true)
        try{
            const response = await courierManagerOrderDetail(id);
            set_detailLadda(false)
            console.log(response.data)
            set_detail(response.data)
            set_showDetailModal(true);
        }catch (e) {
            set_detailLadda(false)
        }
    }

    const showDrivers = async () =>{
        set_listDriverLadda(true)
        try{
            const response = await courierManagerCouriers();
            set_listDriverLadda(false)
            console.log(response.data)
            set_drivers(response.data.results);
            set_showModal(true)
        }catch (e) {
            set_listDriverLadda(false)
        }
    }

    const sendToMiare = async (orderId) =>{
        set_listDriverLadda(true)
        try{
            const res = await  sendToMiare_api(orderId)
            set_listDriverLadda(false)
            if(res.data.delivery_data)
                set_item({...item,status:14})
            else
                toaster.notify(({ onClose }) => (<Error   message={"مشکل در ارسال"}/>),{duration: 2000})

        }catch (e) {
            set_listDriverLadda(false)
            console.log(e)
        }
    }

    const closeDriverModal = (res) =>{
        if(res){
            set_driver(res)
        }
        set_showModal(false)
    }


    function numberWithCommas  (x) {
        if (x === 0) {
            return 0
        }
        if(x){
            return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
        }
        return "-"
    }



    const ConvertTMonthName = (month) =>{
        let name= "";
        switch (month) {
            case '01':
                name =  "فروردین";
                break;
            case '02':
                name =  "اردیبهشت";
                break;
            case '03':
                name =  "خرداد";
                break;
            case '04':
                name =  "تیر";
                break;
            case '05':
                name =  "مرداد";
                break;
            case '06':
                name =  "شهریور";
                break;
            case '07':
                name =  "مهر";
                break;
            case '08':
                name =  "آبان";
                break;
            case '09':
                name =  "آذر";
                break;
            case '10':
                name =  "دی";
                break;
            case '11':
                name =  "بهمن";
                break;
            case '12':
                name =  "اسفند";
                break;
            default:
                name =  "---";
        }

        return name;
    }


    const ConvertToJalaliSplited = (date) =>{
        if(date){
            let month = ConvertTMonthName(moment.utc(date.split('+')[0]).format('jMM'));
            let year = moment.utc(date.split('+')[0]).format('jYYYY');
            let day = moment.utc(date.split('+')[0]).format('jDD');
            let hh = moment.utc(date.split('+')[0]).format('HH');
            let mm = moment.utc(date.split('+')[0]).format('mm');
            return day+" "+month+""+year+" - "+hh+":"+mm
        }
    }


    const convertStatusBtn = (s)=>{
        let result = ""
        switch (s) {
            case 13:
                result  =  "آماده ارسال"
                break;
            case 14:
                result  =  "در حال پیدا کردن پیک"
                break;
            case 15:
                result  =  "قبول شده توسط پیک"
                break;
            case 20:
                result  =  "در حال ارسال"
                break;
            case 25:
                result  =  "تحویل شده"
                break;
            case 30:
                result  =  "توسط مشتری کنسل شد"
                break;
            case 31:
                result  =  "توسط دیجیمال کنسل شد"
                break;
            case 32:
                result  =  "توسط میاره کنسل شد"
                break;
        }
        return result;
    }

    const cancelSend = async (d)=>{
        set_cancelSpin(true)
        try{
            const res = await  cancelSend_api(d)
            set_item({...item,status:13})
            set_showDetailModal(false)
            set_cancelSpin(false)
        }catch (e) {
            console.error(e)
            set_cancelSpin(false)
            toaster.notify(({ onClose }) => (<Error   message={"مشکل در کنسل کردن"}/>),{duration: 2000})
        }
    }

    const [cancelSpin,set_cancelSpin] = useState(false)


    const calcClassCard = (i)=>{
        if(i.status===13)
            return "current-card-btn-active"
        if(i.status===20 && i.courier)
            return "current-card-btn-active"

            return "current-card-btn-deActive"


    }

    return(
        <div className="current-card-container">
            <Rodal
                customStyles={{ height: 'auto', bottom: 'auto', top: '50%', transform: 'translateY(-50%)',width:'350px'}}
                animation={"zoom"}
                showCloseButton={false}
                visible={showModal} onClose={()=>set_showModal(false)}>
                <div className="driver-modal-list">
                    {drivers.map(driver=>{
                        return(
                            <ManagementDriverCard closeModal={closeDriverModal} item={driver} order={item}/>
                        )
                    })
                    }
                </div>
            </Rodal>
            <Rodal
                customStyles={{ height: 'auto', bottom: 'auto', top: '50%', transform: 'translateY(-50%)',width:'350px'}}
                animation={"zoom"}
                showCloseButton={false}
                visible={showDetailModal} onClose={()=>set_showDetailModal(false)}>
                <Spin spinning={cancelSpin}>
                    <div className="history-card-modal">

                        <div className="status-row two-item-row">
                            <span>{convertStatusCode(detail.status)}</span>
                            {detail.status===14 || detail.status===15? <span onClick={e=>{
                                cancelSend(detail)
                            }} className="cancel-order-btn">کنسل کردن</span>:null}
                        </div>

                        <div className="head-row">
                            <div className="factor-num">
                                <div className="factor-label">
                                    {detail.uid}
                                </div>
                            </div>
                            <div className="user-sec">
                                {detail && detail.user?<span className="user-label">{detail.user.first_name+" "+detail.user.last_name}</span>:"_"}
                                <img src="/other/g-user.png" alt=""/>
                            </div>
                        </div>

                        {detail.status===15?<div className="head-row">
                            <div className="factor-num">
                                <div className="factor-label">
                                    {detail && detail.delivery_data ? <span className="user-label" style={{marginTop:15}}>{detail.delivery_data.trip.courier.phone_number}</span>:"-"}
                                </div>
                            </div>
                            <div className="user-sec">
                                {detail && detail.delivery_data ? <span className="user-label" style={{marginTop:15}}>{detail.delivery_data.trip.courier.name}</span>:"-"}
                                <img src="/svg/motor-scooter.svg" alt=""/>
                            </div>
                        </div>:null}

                        {detail.status===15?<div className="center-row">
                            <div className="realTime-location">
                                <span onClick={e=>{
                                    let url = detail?.delivery_data?.trip?.courses[0].tracking_url;
                                    window.open(url, "_blank")
                                }}>پیگیری لحظه ای سفارش </span>
                            </div>
                        </div>:null}


                        {/*{detail.status===15?<div className="head-row-driver">*/}
                        {/*    <div className="factor-num">*/}

                        {/*    </div>*/}
                        {/*    <div className="driver-sec">*/}
                        {/*        {detail && detail.delivery_data ? <span className="user-label" style={{marginTop:15}}>{detail.delivery_data.trip.courier.name}</span>:"-"}*/}
                        {/*        <img src="/svg/motor-scooter.svg" alt=""/>*/}
                        {/*    </div>*/}
                        {/*</div>:null}*/}

                        <div className="factor-sec">
                            <div className="factor-item">
                                <span className="factor-item-val amount" > {numberWithCommas(detail.amount)} تومان </span>
                                <span className="factor-item-label amount-label">مبلغ فاکتور  </span>
                            </div>
                            {detail?.delivery_data?.trip?.departed_at?
                            <div className="factor-item">
                                <span className="factor-item-val">{ConvertToJalaliSplited(detail?.delivery_data?.trip?.departed_at)}</span>
                                <span className="factor-item-label">زمان تحویل پیک</span>
                            </div>:null}

                            {/*<div className="factor-item">*/}
                            {/*    <span className="factor-item-val g-theme">{ConvertToJalaliSplited(detail.delivery_due)}</span>*/}
                            {/*    <span className="factor-item-label">زمان سررسید تحویل</span>*/}
                            {/*</div>*/}

                            {detail.status===15?<div className="address-item">
                                <span>آدرس : </span>
                                <p>{detail?.delivery_data?.trip?.courses[0].address}</p>
                            </div>:
                                null}

                        </div>

                        <div className="factor-subItems-collapse" onClick={()=>{
                            set_attribExpand(!attribExpand)
                        }}>
                            <span>ریز اقلام</span>
                            <i className="fa fa-angle-down"></i>
                        </div>
                        <div className="factor-sub-items">
                            <Expand open={attribExpand}>
                                <div className="factor-table" style={{paddingBottom:120}}>
                                    <table>
                                        <thead>
                                        <tr>
                                            <th className="product-table-head">جمع کل</th>
                                            {/*<th className="product-table-head">تخفیف</th>*/}
                                            <th className="product-table-head">تعداد</th>
                                            <th className="product-table-head product-table-head-name">نام کالا</th>
                                            <th className="product-table-head product-table-head-name">تصویر</th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        {detail && detail.items  && detail.items?.filter(f=>!f.is_canceled).map(product => {
                                            return (
                                                <tr key={product.uid}>
                                                    <td className="product-price">{numberWithCommas(product.amount)}</td>
                                                    {/*<td className="product-count">{numberWithCommas(product.per_discount)}</td>*/}
                                                    <td className="product-count">{product.quantity}</td>
                                                    <td className="product-name">{product.name?product.name:product.product?product.product.name:""}</td>
                                                    <td className="product-name">
                                                        {product.product?<img src={product.product && product.product.image ? product.product.image : "/other/skeleton/product.jpg"} alt=""/>:null}
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        }
                                        </tbody>
                                    </table>

                                    <div className="factor-table-total-row customer_discount-row">
                                        <div className="factor-table-total--price customer_discount-val">
                                            <span>تومان</span>
                                            {<span>0</span>}
                                        </div>
                                        <span className="customer_discount"> : تخفیف  </span>
                                    </div>

                                    <div className="factor-table-total-row">
                                        <div className="factor-table-total--price">
                                            <span>تومان</span>
                                            {detail.amount ? <span>{numberWithCommas(detail.amount)}</span> : null}
                                        </div>
                                        <span> : جمع کل  </span>
                                    </div>
                                </div>
                            </Expand>
                        </div>
                    </div>

                </Spin>
            </Rodal>
            <div
                onClick={()=>{
                    if(item.delivery_type==="merchant"){
                        if(item.status===13 || item.status===20){
                            showDrivers(item.uid)
                        }
                    }
                    else{
                        if(item.status===13)
                            sendToMiare(item.uid)
                    }

                }}
                className={calcClassCard(item)}>
                {

                    !listDriverLadda?
                        // <span>{driver?driver.first_name+" "+driver.last_name:"ارسال به میاره"}</span>
                        // <span>{convertStatusBtn(item.status)}</span>
                        <span>{driver?driver.first_name+" "+driver.last_name:convertStatusBtn(item.status)}</span>
                        :<i className="fa fa-spinner fa-spin"></i>
                }
            </div>
            <div className="history-card-info" onClick={()=>{
                showDetail(item.uid)
            }}>
                <div className="current-card-info">
                    <span className="name" style={{fontFamily:"YekanRegular"}}>{item?.user?.first_name+" "+item?.user?.last_name}</span>
                    <span className="status">{convertStatusCode(item.status)}</span>

                </div>
                {!detailLadda?
                    <img src="/svg/green-basket.svg" alt=""/>:
                    <i className="fa fa-spinner fa-spin"></i>
                }
            </div>
        </div>
    )

}

export {ManagementCurrentCard}


